'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _reactI18next = require('react-i18next');

var _basketHelpers = require('helpers/basketHelpers');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ServiceDetails(props) {
  var components = props.components,
      segment = props.segment,
      t = props.t;


  var AirSegmentDuration = (0, _basketHelpers.getAirSegmentDuration)(segment);
  var CabinClass = (0, _basketHelpers.getCabinClass)(segment) || t('common.na');
  var BookingClass = (0, _basketHelpers.getBookingClass)(segment);
  var Aircraft = (0, _basketHelpers.getAircraft)(segment) || t('common.na');
  var OperatedBy = (0, _basketHelpers.getOperatedBy)(segment) || t('common.na');
  var BaggageAllowance = (0, _basketHelpers.getBaggageAllowance)(segment) || t('air.none');
  var Stopovers = (0, _basketHelpers.getStopovers)(segment) || t('air.none');

  var styleDurationContainer = {
    backgroundColor: components.DurationContainer.backgroundColor
  };

  var styleDurationLabel = {
    color: components.DurationLabel.color,
    fontSize: components.DurationLabel.fontSize,
    fontWeight: components.DurationLabel.fontWeight,
    fontStyle: components.DurationLabel.fontStyle,
    textDecoration: components.DurationLabel.textDecoration,
    fontFamily: components.DurationLabel.fontFamily
  };

  var styleDurationValue = {
    color: components.DurationValue.color,
    fontSize: components.DurationValue.fontSize,
    fontWeight: components.DurationValue.fontWeight,
    fontStyle: components.DurationValue.fontStyle,
    textDecoration: components.DurationValue.textDecoration,
    fontFamily: components.DurationValue.fontFamily
  };

  return _react2.default.createElement(
    'table',
    { style: { borderCollapse: 'collapse', width: '100%' }, 'data-component': 'ServiceDetails' },
    _react2.default.createElement(
      'tbody',
      null,
      _react2.default.createElement(
        'tr',
        null,
        _react2.default.createElement(
          'td',
          { style: (0, _extends3.default)({}, styleDurationContainer, { padding: '10px' }) },
          _react2.default.createElement(
            'table',
            { style: { borderCollapse: 'collapse', width: '100%' }, 'data-component': 'ServiceDetails_Sub' },
            _react2.default.createElement(
              'tbody',
              null,
              _react2.default.createElement(
                'tr',
                null,
                _react2.default.createElement(
                  'td',
                  { style: { padding: '0' } },
                  CabinClass && _react2.default.createElement(
                    'span',
                    { style: styleDurationLabel },
                    t('air.cabin')
                  ),
                  CabinClass && _react2.default.createElement(
                    'span',
                    { style: styleDurationValue },
                    CabinClass,
                    ' '
                  ),
                  BookingClass && _react2.default.createElement(
                    'span',
                    { style: styleDurationValue },
                    '(',
                    BookingClass,
                    ') '
                  ),
                  AirSegmentDuration && _react2.default.createElement(
                    'span',
                    { style: styleDurationLabel },
                    t('air.duration')
                  ),
                  AirSegmentDuration && _react2.default.createElement(
                    'span',
                    { style: styleDurationValue },
                    AirSegmentDuration,
                    ' '
                  ),
                  Aircraft && _react2.default.createElement(
                    'span',
                    { style: styleDurationLabel },
                    t('air.aircraft')
                  ),
                  Aircraft && _react2.default.createElement(
                    'span',
                    { style: styleDurationValue },
                    Aircraft,
                    ' '
                  ),
                  OperatedBy && _react2.default.createElement(
                    'span',
                    { style: styleDurationLabel },
                    t('air.operated')
                  ),
                  OperatedBy && _react2.default.createElement(
                    'span',
                    { style: styleDurationValue },
                    OperatedBy,
                    ' '
                  ),
                  BaggageAllowance && _react2.default.createElement(
                    'span',
                    { style: styleDurationLabel },
                    t('air.baggage')
                  ),
                  BaggageAllowance && _react2.default.createElement(
                    'span',
                    { style: styleDurationValue },
                    BaggageAllowance,
                    ' '
                  ),
                  Stopovers && _react2.default.createElement(
                    'span',
                    { style: styleDurationLabel },
                    t('air.stopover')
                  ),
                  Stopovers && _react2.default.createElement(
                    'span',
                    { style: styleDurationValue },
                    Stopovers,
                    ' '
                  )
                )
              )
            )
          )
        )
      )
    )
  );
}

var mstp = function mstp(state) {
  return {
    components: state.templateApplication.templates.currentTemplate.components
  };
};

exports.default = (0, _reactI18next.translate)()((0, _reactRedux.connect)(mstp)(ServiceDetails));
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/TemplateComponents/Air/Email/ServiceDetails.jsx
// module id = 1483
// module chunks = 0